import { useCallback, useEffect, useState } from 'react';

export type ThemeMode = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'vitalai.theme-mode';

function readStoredMode(): ThemeMode {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark' || stored === 'system') return stored;
  } catch {
    // localStorage puede no estar disponible (modo privado); usamos el default.
  }
  return 'system';
}

export function useThemeMode(): [ThemeMode, (mode: ThemeMode) => void] {
  const [mode, setMode] = useState<ThemeMode>(readStoredMode);

  useEffect(() => {
    const root = document.documentElement;
    if (mode === 'system') {
      root.removeAttribute('data-theme');
    } else {
      root.setAttribute('data-theme', mode);
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // Ignorar: preferencia de tema no persistira entre sesiones.
    }
  }, [mode]);

  const updateMode = useCallback((next: ThemeMode) => setMode(next), []);

  return [mode, updateMode];
}
